export type ProductGridViewMode = 'editorial' | 'grid4' | 'grid6' | 'grid8';

export type ProductGridViewUiMode = 'grid6' | 'grid8';

export const PRODUCT_GRID_VIEW_STORAGE_KEY = 'b2b-product-grid-view';

export const PRODUCT_GRID_VIEW_UI_MODES: ProductGridViewUiMode[] = ['grid6', 'grid8'];

const STORED_MODES: ProductGridViewMode[] = ['editorial', 'grid4', 'grid6', 'grid8'];

export function readProductGridView(): ProductGridViewUiMode {
    try {
        const stored = localStorage.getItem(PRODUCT_GRID_VIEW_STORAGE_KEY);
        if (stored === 'grid8') {
            return 'grid8';
        }
        if (stored === 'grid6') {
            return 'grid6';
        }
        // Legacy grid4 / editorial preferences fall back to default grid6
        if (stored && STORED_MODES.indexOf(stored as ProductGridViewMode) !== -1) {
            return 'grid6';
        }
    } catch {
        /* ignore */
    }
    return 'grid6';
}

export function writeProductGridView(mode: ProductGridViewUiMode): void {
    try {
        localStorage.setItem(PRODUCT_GRID_VIEW_STORAGE_KEY, mode);
    } catch {
        /* ignore */
    }
}

export function plClassName(mode: ProductGridViewMode): string {
    return `pl pl--view-${mode}`;
}

export function editorialItemClass(index: number): string {
    return index % 6 < 2
        ? 'pl-item__wrapper--editorial-half'
        : 'pl-item__wrapper--editorial-quarter';
}

export function wrapperClassName(
    mode: ProductGridViewMode,
    index: number,
    base = 'pl-item__wrapper ripple'
): string {
    if (mode !== 'editorial') {
        return base;
    }
    return `${base} ${editorialItemClass(index)}`;
}

export function isEditorialHalfItem(mode: ProductGridViewMode, index: number): boolean {
    return mode === 'editorial' && index % 6 < 2;
}
